import script from "./StoryEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoryEdit.vue?vue&type=script&setup=true&lang=ts"

import "./StoryEdit.vue?vue&type=style&index=0&id=0d74b3fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d74b3fe"]])

export default __exports__